export const nav_btn_left = (
    <svg
        width="12px"
        height="12px"
        viewBox="0 0 12 12"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        // xmlns:xlink="http://www.w3.org/1999/xlink"
    >
        <title>icon-left</title>
        <g id="page" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="锚点-居中" transform="translate(-270, -234)">
                <g id="navigation" transform="translate(0, 216)">
                    <g id="更多" transform="translate(248, 0)">
                        <g id="icon-left" transform="translate(22, 18)">
                            <rect id="矩形" x="0" y="0" width="12" height="12"></rect>
                            <polyline
                                id="路径-3"
                                stroke="currentColor"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                transform="translate(6, 6) scale(-1, 1) rotate(-90) translate(-6, -6)"
                                points="2 4 6 8 10 4"
                            ></polyline>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const nav_btn_right = (
    <svg
        width="14px"
        height="14px"
        viewBox="0 0 12 12"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        // xmlns:xlink="http://www.w3.org/1999/xlink"
    >
        <title>icon-right</title>
        <g id="page" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="锚点-居中" transform="translate(-1022, -126)">
                <g id="navigation" transform="translate(0, 108)">
                    <g id="更多" transform="translate(1000, 0)">
                        <g id="icon-right" transform="translate(22, 18)">
                            <rect id="矩形" x="0" y="0" width="12" height="12"></rect>
                            <polyline
                                id="路径-3"
                                stroke="currentColor"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                transform="translate(6, 6) rotate(-90) translate(-6, -6)"
                                points="2 4 6 8 10 4"
                            ></polyline>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const ArrowIcon = (
    <svg
        width="10px"
        height="10px"
        viewBox="0 0 10 10"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        className="menu-parent-svg"
    >
        <title>编组 8</title>
        <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="PC导航-胶囊控件展开位置" transform="translate(-356.000000, -25.000000)">
                <g id="编组-6" transform="translate(32.000000, 12.000000)">
                    <g id="导航" transform="translate(190.000000, 0.000000)">
                        <g id="编组-3" transform="translate(0.000000, 6.000000)">
                            <g id="编组-8" transform="translate(134.000000, 7.000000)">
                                <rect id="矩形" x="0" y="0" width="10" height="10"></rect>
                                <polyline
                                    id="路径-3"
                                    stroke="currentColor"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    points="1.45243696 3.50317465 5 7.05073769 8.54756304 3.50317465"
                                ></polyline>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const footIcon = (
    <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        // xmlns:xlink="http://www.w3.org/1999/xlink"
    >
        <title>收起</title>
        <g id="H5" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="navigation+footer" transform="translate(-694, -664)">
                <g id="footer" transform="translate(0, 618)">
                    <g id="收起" transform="translate(706, 58) rotate(-180) translate(-706, -58)translate(694, 46)">
                        <rect id="矩形" x="0" y="0" width="24" height="24"></rect>
                        <polyline
                            id="路径-3"
                            stroke="#FFFF"
                            strokeWidth="2.4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            points="3.4858487 8.40761916 12 16.9217705 20.5141513 8.40761916"
                        ></polyline>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const linkArrow = (
    <svg width="14px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <title>icon_play备份 7@2x</title>
        <g id="终稿标注文件" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="千帆大模型平台产品定制页-第六版-1200" transform="translate(-844, -2433)">
                <g id="编组-25" transform="translate(55, 2375)">
                    <g id="编组-2" transform="translate(789, 58)">
                        <g id="蒙版"></g>
                        <g mask="url(#mask-2)" strokeWidth="1.2">
                            {/* eslint-disable-next-line max-len */}
                            <g transform="translate(7.3569, 8.7838) rotate(-45) translate(-7.3569, -8.7838)translate(0.9569, 3.127)">
                                <polyline
                                    id="路径"
                                    stroke="currentColor"
                                    transform="translate(7.0843, 5.6569) rotate(45) translate(-7.0843, -5.6569)"
                                    points="3.0842628 1.65685425 11.0842628 1.65685425 11.0842628 9.65685425"
                                ></polyline>
                                <line
                                    x1="0.0551256324"
                                    stroke="currentColor"
                                    y1="5.55736354"
                                    x2="12.3999877"
                                    y2="5.65448991"
                                    id="路径-2"
                                    strokeLinejoin="round"
                                ></line>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);
